// DashboatrdService (sic — do NOT rename, imports depend on the typo).
// Migrated to the OpenAPI-generated client:
//   - admin/statistics            -> adminStatisticsControllerGet
//   - admin/statistics/enhanced   -> adminStatisticsControllerGetEnhancedStats
//   - system/statistics/company-breakdown -> systemStatisticsControllerGetCompanyBreakdown (SYSTEM_ADMIN)
// The server derives the company from the caller's principal (IDOR sweep) — /admin/statistics has no
// companyId query — so the legacy `companyId` argument is accepted for signature compatibility but NOT
// forwarded. Each function returns `{data}` (callers read res.data) and re-throws an axios-shaped error.

import {
  adminStatisticsControllerGet,
  adminStatisticsControllerGetEnhancedStats,
  systemStatisticsControllerGetArboxCollections,
  systemStatisticsControllerGetCompanyBreakdown,
} from '../api/generated';

// Preserve the legacy axios rejection shape so call sites reading `e.response.data.errorCode` keep working.
const throwLikeAxios = (error, response) => {
  throw {response: {data: error, status: response?.status}};
};

// eslint-disable-next-line no-unused-vars
export const getStatistics = async (companyId) => {
  const {data, error, response} = await adminStatisticsControllerGet();
  if (error) throwLikeAxios(error, response);
  return {data};
};

export const getCompanyBreakdown = async () => {
  const {data, error, response} = await systemStatisticsControllerGetCompanyBreakdown();
  if (error) throwLikeAxios(error, response);
  return {data};
};

// Month-to-date money collected through Arbox, for the super-admin dashboard tile. SYSTEM_ADMIN only —
// the endpoint 403s for a COMPANY_GROUP_ADMIN, so only call it for a super admin.
export const getArboxCollections = async () => {
  const {data, error, response} = await systemStatisticsControllerGetArboxCollections();
  if (error) throwLikeAxios(error, response);
  return {data};
};

// eslint-disable-next-line no-unused-vars
export const getEnhancedStatistics = async (companyId) => {
  const {data, error, response} = await adminStatisticsControllerGetEnhancedStats();
  if (error) throwLikeAxios(error, response);
  return {data};
};
